import React, { useEffect, useState } from 'react';
import { Cat } from '../../types';

import { declOfNum, prepareAge } from '../../utils';

import { Box, CountBox, NumberBox, DescriptionBox } from './styles';

type Props = {
    cat: Cat;
}

export const Counts = ({ cat }: Props) => {
    const [friendsCount, setFriendsCount] = useState(0);
    const { age } = cat ? prepareAge(cat.createdAt) : { age: 0 };
    const likes = cat.likes || 0;

    useEffect(() => {
        const requestFriendsCount = async () => {
            try {
                const response = await fetch(`/cats/api/friends?catId=${cat.id}`);

                const { count } = await response.json();

                if (typeof count === 'number') {
                    setFriendsCount(count);
                }
            } catch (err) {
                console.log(err)
            }
        }

        requestFriendsCount();
    }, [])

    return (
        <Box>
            <CountBox>
                <NumberBox>
                    {age}
                </NumberBox>
                <DescriptionBox>
                    {declOfNum(age, ['день', 'дня', 'дней'])}
                </DescriptionBox>
            </CountBox>
            <CountBox>
                <NumberBox>
                    {likes}
                </NumberBox>
                <DescriptionBox>
                    {declOfNum(likes, ['лайк', 'лайка', 'лайков'])}
                </DescriptionBox>
            </CountBox>
            <CountBox>
                <NumberBox>
                    {friendsCount}
                </NumberBox>
                <DescriptionBox>
                    {declOfNum(friendsCount, ['друг', 'друга', 'друзей'])}
                </DescriptionBox>
            </CountBox>
        </Box>
    )
}